import React from 'react';
import axios from 'axios'
import Desktop from './desktop';
import Mobile from './mobile';
import Slot from './mobile/slot';
import Footer from './mobile/footer';
import { useRouter } from './hook/useRouter';
import { Route } from 'react-router-dom';
import { setPostVisite } from './store/partners/thunk/setPostVisite';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch } from 'react-redux';

const App = () => {
    const dispatch = useDispatch();
    const router = useRouter();

    axios.defaults.headers['Organization'] = 1;
    axios.defaults.headers['VisualViewPortHeight'] = window?.visualViewport?.height;
    axios.defaults.headers['VisualViewPortWidth'] = window?.visualViewport?.width;
    axios.defaults.headers['VisualViewPortScale'] = window?.visualViewport?.scale;
    axios.defaults.headers['ClientInformationAppCodeName'] = window?.clientInformation?.appCodeName;
    axios.defaults.headers['ClientInformationAppName'] = window?.clientInformation?.appName;
    axios.defaults.headers['ClientInformationAppVersion'] = window?.clientInformation?.appVersion;
    axios.defaults.headers['ClientInformationLanguage'] = window?.clientInformation?.language;
    axios.defaults.headers['ClientInformationUserAgent'] = window?.clientInformation?.userAgent;
    axios.defaults.headers['DeviceWidth'] = window?.screen?.width;
    axios.defaults.headers['DeviceHeight'] = window?.screen?.height;
    axios.defaults.headers['DevicePlatform'] = window?.navigator?.platform;

    const [isShowModal, handleSetIsShowModal] = React.useState(false);


    const utm_source = router.query?.utm_source;
    const utm_medium = router.query?.utm_medium;
    const utm_campaign = router.query?.utm_campaign;
    const utm_content = router.query?.utm_content;
    const utm_term = router.query?.utm_term;

    const stream = router.query?.stream;
    const s1 = router.query?.s1;
    const s2 = router.query?.s2;
    const s3 = router.query?.s3;
    const s4 = router.query?.s4;
    const s5 = router.query?.s5;

    if (utm_term) {
        localStorage.setItem('utm_term', utm_term)
    }
    if (utm_source) {
        localStorage.setItem('utm_source', utm_source)
    }
    if (utm_medium) {
        localStorage.setItem('utm_medium', utm_medium)
    }
    if (utm_campaign) {
        localStorage.setItem('utm_campaign', utm_campaign)
    }
    if (utm_content) {
        localStorage.setItem('utm_content', utm_content)
    }
    if (stream) {
        localStorage.setItem('stream', stream)
    }
    if (s1) {
        localStorage.setItem('s1', s1)
    }
    if (s2) {
        localStorage.setItem('s2', s2)
    }
    if (s3) {
        localStorage.setItem('s3', s3)
    }
    if (s4) {
        localStorage.setItem('s4', s4)
    }
    if (s5) {
        localStorage.setItem('s5', s5)
    }

    if (router?.query?.language) {
        localStorage.setItem('language', router?.query?.language?.toString()?.toLowerCase())
    }



    function readCookie(name) {
        var matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    const cookie = readCookie('win777');

    if (!cookie) {
        const date = new Date;
        date.setDate(date.getDate() + 360);
        const uuid = uuidv4();
        document.cookie = `win777=${uuid}; path=/; expires=${date.toUTCString()}`;
        axios.defaults.headers = {
            organization: 1,
            SessionConnect: uuid
        }
    } else {
        axios.defaults.headers = {
            organization: 1,
            SessionConnect: cookie
        }
    }

    React.useEffect(() => {
        dispatch(setPostVisite())
    }, [])

    const isRedirect = localStorage.getItem('redirect');

    React.useEffect(() => {
        if (isRedirect) {
            window.location.replace(localStorage.getItem('redirect'))
        }
    }, [isRedirect])

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
        return (
            <div style={{ background: 'linear-gradient(93deg, rgba(20,29,89,1) 0%, rgba(14,20,68,1) 100%)' }}>
                <Mobile isShowModal={isShowModal} handleSetIsShowModal={handleSetIsShowModal} />
                <Slot handleSetIsShowModal={handleSetIsShowModal} />
                <Footer />
            </div>
        )
    } else {
        return (
            <div>
                <Route path="/" component={() => <Desktop />} />
            </div>
        )
    }
}

export default App;